import { useState } from "react";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const inputCls = "w-full rounded-xl border-2 border-purple-500/30 bg-black/40 px-3 py-2.5 text-right text-white outline-none focus:border-[var(--km-pink)]";
const EMPTY = { current: "", next: "", confirm: "" };

export const AccountSettings = () => {
  const [f, setF] = useState(EMPTY);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 10) return setError("كلمة السر الجديدة لازم تكون 10 حروف على الأقل");
    if (f.next !== f.confirm) return setError("تأكيد كلمة السر مش مطابق");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setF(EMPTY);
      toast.success("كلمة السر اتغيرت بنجاح");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="max-w-lg" data-testid="account-settings">
      <h2 className="font-display mb-2 text-3xl text-white">تغيير كلمة السر</h2>
      <p className="mb-6 text-sm text-purple-300/70">غيّر كلمة السر المؤقتة لكلمة سر قوية تعرفها انت بس.</p>
      <form onSubmit={submit} className="space-y-4 rounded-3xl border border-purple-500/25 bg-[var(--km-card)] p-6" data-testid="change-password-form">
        {[["current", "كلمة السر الحالية", "current-password"], ["next", "كلمة السر الجديدة (10 حروف على الأقل)", "new-password"], ["confirm", "أكّد كلمة السر الجديدة", "new-password"]].map(([k, label, ac]) => (
          <label key={k} className="block">
            <span className="mb-1 block text-sm font-bold text-white">{label}</span>
            <input type="password" dir="ltr" autoComplete={ac} className={inputCls} value={f[k]} onChange={set(k)} required data-testid={`password-${k}-input`} />
          </label>
        ))}
        {error && <p className="rounded-xl bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="change-password-error">{error}</p>}
        <button type="submit" disabled={busy} className="font-head inline-flex items-center gap-2 rounded-full bg-[var(--km-pink)] px-6 py-2.5 font-bold text-white disabled:opacity-60" data-testid="change-password-submit-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} حفظ كلمة السر
        </button>
      </form>
    </section>
  );
};
